import { type FC } from 'react'
import { useTranslation } from 'react-i18next'

import BookingWidget from '@/containers/BookingWidget/BookingWidget'

const MakeAppointmentPage: FC = () => {
  const { i18n } = useTranslation()

  const widgetConfig = {
    apiToken: import.meta.env.VITE_BOOKING_WIDGET_API_TOKEN,
    mode: 'embedded',
    integrationType: 'patient-hub',
    language: i18n.language,
  }

  return (
    <div className="widget-container -mx-3.5 -mt-5 md:-mt-0 lg:-mx-0 xl:-mx-5">
      <BookingWidget config={widgetConfig} />
    </div>
  )
}

export default MakeAppointmentPage
